import { clientFor } from '@yc/api-client'

const api = clientFor('/ops/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 今天创建的运输订单数 */
  today_orders: number
  /** 当前在途的订单数 */
  in_transit_orders: number
  /** 还没进结算单的待结算计费笔数 */
  unsettled_count: number
  /** 待结算计费金额合计（未挂结算单的部分） */
  unsettled_amount: number
  /** 还没确认的结算单数 */
  draft_settlements: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
